import { createContext } from 'react';

type SiteEditContextModel = {
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
};

export const SiteEditContext = createContext<SiteEditContextModel>({
    isEditing: false,
    setIsEditing: () => undefined,
});
